import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Comparação Prop Firms', path: '/comparacao' },
  { label: 'Estratégias', path: '/estrategias' },
  { label: 'Artigos', path: '/artigos' },
  { label: 'Trading Live', path: '/trading-live' },
  { label: 'Sobre Nós', path: '/sobre' },
  { label: 'Contactos', path: '/contactos' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0d1f3c] border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 shrink-0">
          <img
            src="https://public.readdy.ai/ai/img_res/60efb351-2a84-48c0-b918-15f9914dd197.png"
            alt="Diário de 1 Trader Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-white bg-white/15'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <a
          href="/comparacao"
          className="hidden md:flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-award-line"></i>
          Melhores Prop Firms
        </a>

        {/* Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer text-white"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-blue-100 px-4 py-4 flex flex-col gap-1 shadow-lg">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-all cursor-pointer ${
                location.pathname === link.path
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-slate-700 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="/comparacao"
            className="mt-2 flex items-center justify-center gap-2 bg-blue-600 text-white text-sm font-semibold px-5 py-3 rounded-full cursor-pointer"
          >
            <i className="ri-award-line"></i>
            Melhores Prop Firms
          </a>
        </div>
      )}
    </header>
  );
}
